import styled from 'styled-components'

export const Message = styled.div`
  color: #ff424f;
  font-size: 1.2rem;
  padding-top: 0.5rem;
`
